// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__18XFe","alertIcon":"ConfirmModal_alertIcon__WW1mq"};